module.exports = __webpack_public_path__ + "static/media/VectorCoreID.f4613696.svg";